import React, { useEffect, useRef } from 'react';

const NightSky = () => {
  const nightSkyRef = useRef(null);

  useEffect(() => {
    if (nightSkyRef.current) {
      nightSkyRef.current.setAttribute('layers', '4');
      nightSkyRef.current.setAttribute('density', '10');
      nightSkyRef.current.setAttribute('velocity-x', '40');
      nightSkyRef.current.setAttribute('velocity-y', '40');
      nightSkyRef.current.setAttribute('star-color', '#FFF');
      nightSkyRef.current.setAttribute('background-color', 'transparent');
    }
  }, []);

  return (
    <night-sky ref={nightSkyRef} style={{ position: 'fixed', width: '100%', height: '100%', top: 0, left: 0, zIndex: -1,  background: "black"  }}></night-sky>
  );
};

export default NightSky;
